import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import classNames from "classnames";

interface DatepickerInputProps {
  onClick?: () => void;
  value?: string;
  inputClass: string;
  children?: React.ReactNode;
}

/* Datepicker with Input */
const DatepickerInput = forwardRef<HTMLInputElement, DatepickerInputProps>(
  (props, ref) => (
    <input
      type="text"
      className={classNames("form-control", props.inputClass)}
      onClick={props.onClick}
      value={props.value}
      onChange={() => {}}
      ref={ref}
    />
  )
);

/* Datepicker with Addon Input */
const DatepickerInputWithAddon = forwardRef<
  HTMLInputElement,
  DatepickerInputProps
>((props, ref) => (
  <div className="input-group input-group-sm" ref={ref}>
    <input
      type="text"
      className={classNames("form-control", props.inputClass)}
      onClick={props.onClick}
      value={props.value}
      readOnly
    />
    <span className="input-group-text bg-blue border-blue text-white">
      <i className="mdi mdi-calendar-range"></i>
    </span>
  </div>
));

interface HyperDatepickerProps {
  value: Date | null | [Date | null, Date | null] | undefined;
  onChange: (date: any) => void;
  selectsRange?: boolean;
  hideAddon?: boolean;
  inputClass?: string;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  showTimeSelect?: boolean;
  tI?: number;
  timeCaption?: string;
  timeFormat?: string;
  showTimeSelectOnly?: boolean;
  disabled?: boolean;
  monthsShown?: number;
  inline?: boolean;
  isClearable?: boolean;
}

const HyperDatepicker = (props: HyperDatepickerProps) => {
  const days = ["D", "S", "T", "Q", "Q", "S", "S"];
  const months = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const locale = {
    localize: {
      day: (n: any) => days[n],
      month: (n: any) => months[n],
    },
    formatLong: {
      date: () => "dd/MM/yyyy",
    },
  };
  // handle custom input
  const input =
    props.hideAddon ? (
      <DatepickerInput inputClass={props.inputClass!} />
    ) : (
      <DatepickerInputWithAddon inputClass={props.inputClass!} />
    );

  return (
    <>
      {/* date picker control */}
      <DatePicker
        disabled={props.disabled}
        locale={locale as any}
        customInput={input}
        timeIntervals={props.tI}
        selected={!props.selectsRange ? (props.value as Date | null) : undefined}
        onChange={(date) => props.onChange(date as any)}
        showTimeSelect={props.showTimeSelect}
        timeFormat={props.timeFormat || "hh:mm a"}
        timeCaption={props.timeCaption}
        dateFormat={props.dateFormat || "dd/MM/yyyy"}
        minDate={props.minDate}
        maxDate={props.maxDate}
        monthsShown={props.monthsShown}
        showTimeSelectOnly={props.showTimeSelectOnly}
        inline={props.inline}
        autoComplete="off"
        isClearable={props.isClearable}
        selectsRange={props.selectsRange}
        startDate={props.selectsRange ? (props.value as [Date | null, Date | null])[0] : undefined}
        endDate={props.selectsRange ? (props.value as [Date | null, Date | null])[1] : undefined}
      />
    </>
  );
};

export default HyperDatepicker;
